import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { LocationNodeType } from '@app/shared/models/location-node';

type LegacyLocationRouteTarget = 'list' | 'detail' | 'create';

export function legacyLocationRedirect(
    target: LegacyLocationRouteTarget,
    type?: LocationNodeType,
    legacyParentQueryKey?: 'buildingId' | 'floorId'
): RedirectFunction {
    return route => {
        const router = inject(Router);
        const currentUrl = router.getCurrentNavigation()?.extractedUrl;
        const queryParams = {
            ...(currentUrl?.queryParams ?? {}),
            ...(route.queryParams ?? {})
        };
        const fragment = route.fragment ?? currentUrl?.fragment ?? undefined;

        if (target === 'list') {
            return router.createUrlTree(['/location-storage'], { queryParams, fragment });
        }

        if (target === 'detail') {
            return router.createUrlTree(
                ['/location-storage', route.paramMap.get('id')],
                { queryParams, fragment }
            );
        }

        const parentId = queryParams['parentId']
            ?? (legacyParentQueryKey ? queryParams[legacyParentQueryKey] : null);
        delete queryParams['buildingId'];
        delete queryParams['floorId'];

        return router.createUrlTree(['/location-storage/new-item'], {
            queryParams: {
                ...queryParams,
                parentId: parentId || null,
                type: type ?? queryParams['type'] ?? null
            },
            fragment
        });
    };
}
